<template>
  <div class="admin-page">
    <div class="layout__content__header">
      <app-back :text="'zpetDoPortalu'" :route="backRoute" :white="true" />
      <h1 class="text-center mb-2 mb-md-3">
        {{ $t("menuSpravce") }}
      </h1>
    </div>
    <div class="layout__content__content">
      <router-view :key="$route.fullPath" />
    </div>
  </div>
</template>

<script>
import Back from "@/components/back.vue"
import { useConfigStore } from "@/store/modules/config"
import { useProjectStore } from "@/store/modules/project"
export default {
  components: {
    "app-back": Back
  },
  setup() {
    const configStore = useConfigStore()
    const projectStore = useProjectStore()

    return { configStore, projectStore }
  },
  computed: {
    // Computed, not data: a project created from this page arrives after mount and the
    // back link has to pick it up. The store is preferred over the route param, which
    // still holds the id of a project deleted from the admin menu.
    projectId() {
      return this.projectStore.selectedProject?.projectId || ""
    },
    customerId() {
      return this.$route.params.customerId
    },
    backRoute() {
      // Without a project there is no dashboard to go back to — /dashboard/<customerId>/
      // matches no route and would land on the 404 page.
      return this.projectId ? `/dashboard/${this.customerId}/${this.projectId}` : "/"
    }
  },
  watch: {},
  mounted() {
    if (!localStorage.getItem("showTutorialLaterAdmin")) {
      this.configStore.isAdminTutorialVisible = true
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped></style>
